import React, {useContext} from 'react';
import { useTranslation } from "react-i18next";
import ToggleSwitch from 'components/ToggleSwitch/ToggleSwitch';
import CatbearsFeedbackBtn from 'components/CatbearsFeedbackBtn/CatbearsFeedbackBtn';
import "./LogoCatbears.scss"
import FeedbackPopup from 'components/Popups/FeedbackPopup/FeedbackPopup';
import { GlobalContext } from "context/GlobalContext";
import { useHistory } from 'react-router-dom';

function LogoCatbears({isSoundSwitch, isFeedbackBtn, isHovering, hideLogoOnMobile, hideLogoOnDesktop, isCentered, isTapToLandingPage, isFixed = true}) {

  const {ShowFeedback, setShowFeedback} = useContext(GlobalContext);
  const history = useHistory();


  function closeFeedbackPopup () {
    setShowFeedback(false)
  }

  const goHome = () => {
    isTapToLandingPage && history.push('/');
  }

  function onClick (){
    if(isTapToLandingPage) window.location.href = 'https://app.catbears.com';
  }
  const {i18n } = useTranslation();

  return (
    <>
      {ShowFeedback && 
        <FeedbackPopup 
          closeFeedbackPopup={closeFeedbackPopup}
          feedbackSource={"theatre"}
        />
      }
    <div className={"LogoCatbears-container noselect " + (hideLogoOnMobile && "hideLogoOnMobile") + " " + (hideLogoOnDesktop && "hideLogoOnDesktop") + " " + (isCentered && "LogoCatbears-container__centered") + " " + (!isFixed && "LogoCatbears-container--static")}>
      <div className="toggle-switch ">
        {isSoundSwitch && <ToggleSwitch isSFX /> }
        {isFeedbackBtn && <CatbearsFeedbackBtn />}
      </div>
        <img onClick={goHome} className={"catbears-logo "} src={(i18n.translator.language != `he` ? "/assets/icons/logo-catbears__en.png" : "/assets/icons/logo-catbears_he.png")}/>
    </div>
    </>
  );
}

export default LogoCatbears;

// "hovering"
